import React, { useEffect, useState } from "react";
import moment from "moment";
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { Formik } from "formik";
import { Datepicker, Form } from "react-formik-ui";
import { connect } from "react-redux";

import notificationSound from "../assets/music/hey-pay-some-attention.mp3";

import "./AdminPanel.scss";

const AdminPanel = ({ firestore }) => {
    const [actualOrders, setActualOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [noMoreOrders, setNoMoreOrders] = useState(false);
    const [lastQuery, setLastQuery] = useState({});
    const audio = new Audio(notificationSound);

    useEffect(() => {
        const getNewOrders = async () => {
            // handle query
            let query = await firestore
                .collection("orders")
                .orderBy("newOrder.ts", "desc")
                .limit(5);
            setLastQuery(query);
            await query.onSnapshot(snapshotDocument => {
                const orders = snapshotDocument.docs.map(doc => {
                    return {
                        id: doc.id,
                        isRead: false,
                        ...doc.data()
                    };
                });
                setActualOrders(orders);
                setFilteredOrders(orders);
            });
        };

        getNewOrders();
    }, [firestore]);

    const filterOrders = async date => {
        let mDate = moment(date.date).format();
        console.log("TCL: filterOrders -> mDate", mDate);
        const ordersRef = await firestore.collection("orders");
        let tempDocsTs = [];
        await ordersRef.get().then(doc => {
            let documents = doc.docs;
            documents.forEach(document => {
                let tDoc = document.data();
                if (moment(tDoc.newOrder.ts).isSame(mDate, "date")) {
                    tempDocsTs.push(tDoc);
                }
            });
        });

        setFilteredOrders(tempDocsTs);
    };

    const handleReadOrder = async id => {
        return await firestore
            .collection("orders")
            .doc(id)
            .update({
                isRead: true
            });
    };

    useEffect(() => {
        notification(actualOrders);
    }, [actualOrders]);

    const renderOrders = orders => {
        return orders.map(order => {
            let time = moment(order.newOrder.ts).format("DD-MM-YYYY HH:mm:ss");
            let notificate = order.isRead ? "" : "notificate";
            return (
                <div
                    className={`adminPanel__ordersWrapper__order ${notificate}`}
                    key={order.id}
                    onClick={() => handleReadOrder(order.id)}
                >
                    {/* Order number div */}
                    <div className="adminPanel__ordersWrapper__order-orderTrack">
                        <p>
                            Order
                            <br />
                            {time}
                        </p>
                    </div>
                    {/* Ordered items div i think <ul> will be perfect here */}
                    <div className="adminPanel__ordersWrapper__order-orderedItems">
                        {order.newOrder.order.map((food, i) => (
                            <p key={i}>
                                {food.name} <b>x{food.amount}</b>
                            </p>
                        ))}
                    </div>
                    {/* Reciver information div */}
                    <div className="adminPanel__ordersWrapper__order-reciverInfo">
                        <p>
                            {order.newOrder.form.firstName} {order.newOrder.form.lastName}
                        </p>
                        <p>{order.newOrder.form.email}</p>
                        <p>{order.newOrder.form.phone}</p>
                        <p>
                            {order.newOrder.form.address}, {order.newOrder.form.city}
                        </p>
                        <p>{order.newOrder.form.extraNote}</p>
                    </div>
                </div>
            );
        });
    };

    const notification = async newOrders => {
        if (newOrders.length >= 1) {
            if (newOrders[0].isRead === false) {
                audio.play();
            }
        }
    };

    const handleShowMore = async lastQuery => {
        return await lastQuery.get().then(documentSnapshots => {
            // Get the last visible document
            var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];

            let nextQuery;
            try {
                nextQuery = firestore
                    .collection("orders")
                    .orderBy("newOrder.ts", "desc")
                    .startAfter(lastVisible)
                    .limit(5);
            } catch (e) {
                console.log(e);
                setNoMoreOrders(true);
                return;
            }

            console.log("TCL: AdminPanel -> nextQuery", nextQuery);
            setLastQuery(nextQuery);
            nextQuery.onSnapshot(snapshotDocument => {
                const orders = snapshotDocument.docs.map(doc => {
                    return {
                        id: doc.id,
                        isRead: false,
                        ...doc.data()
                    };
                });
                setActualOrders([...actualOrders, orders].flat());
                setFilteredOrders([...filteredOrders, orders].flat());
            });
        });
    };

    return (
        <section className="adminPanel">
            <div className="pos-bottom triangle-up" />
            <div className="adminPanel__header">
                <h2>Admin Panel</h2>
            </div>
            <div className="adminPanel__filter">
                <Formik
                    initialValues={{
                        date: ""
                    }}
                    onSubmit={async (values, actions) => {
                        filterOrders(values);
                        actions.setSubmitting(false);
                        actions.resetForm();
                    }}
                    render={({ isSubmitting, isValid, errors, touched }) => (
                        <Form mode="themed" className="adminPanel__form">
                            <div className="adminPanel__form-dateWrapper">
                                <Datepicker
                                    name="date"
                                    placeholder="Select a date"
                                    dateFormat="dd.MM.yyyy"
                                    openToDate={new Date()}
                                />
                            </div>

                            <button
                                disabled={!isValid || isSubmitting}
                                className="btn-primaryc plr-25 adminPanel__form-button"
                                type="submit"
                            >
                                Search
                            </button>
                        </Form>
                    )}
                />
            </div>
            <div className="adminPanel__ordersWrapper">
                <h3 style={{ color: "#ffffff" }}>Orders</h3>
                <div className="container">{renderOrders(filteredOrders)}</div>
                <div className="adminPanel__showMore">
                    <button
                        disabled={noMoreOrders}
                        className="adminPanel__showMore--btn"
                        onClick={() => handleShowMore(lastQuery)}
                    >
                        Show more
                    </button>
                </div>
            </div>
        </section>
    );
};

const mapStateToProps = ({ firestore }) => ({
    firestore: firestore
});

export default compose(
    connect(
        mapStateToProps,
        null
    ),
    firestoreConnect([`orders`])
)(AdminPanel);
